/**
 * @generated SignedSource<<31b029567096f07cac2de11d7083a62e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type MediaItemIdType = "DATABASE_ID" | "ID" | "SLUG" | "SOURCE_URL" | "URI";
export type Media_Query_By_Query$variables = {
  id: string;
  idType?: MediaItemIdType | null | undefined;
};
export type Media_Query_By_Query$data = {
  readonly mediaItem: {
    readonly description: string | null | undefined;
    readonly mediaDetails: {
      readonly sizes: ReadonlyArray<{
        readonly name: string | null | undefined;
        readonly sourceUrl: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly mediaItemUrl: string | null | undefined;
    readonly mimeType: string | null | undefined;
  } | null | undefined;
};
export type Media_Query_By_Query = {
  response: Media_Query_By_Query$data;
  variables: Media_Query_By_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "idType"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "idType",
    "variableName": "idType"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mediaItemUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "MediaDetails",
  "kind": "LinkedField",
  "name": "mediaDetails",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MediaSize",
      "kind": "LinkedField",
      "name": "sizes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sourceUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Media_Query_By_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MediaItem",
        "kind": "LinkedField",
        "name": "mediaItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Media_Query_By_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MediaItem",
        "kind": "LinkedField",
        "name": "mediaItem",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "345f55826a1fe93006f00c051606667e",
    "id": null,
    "metadata": {},
    "name": "Media_Query_By_Query",
    "operationKind": "query",
    "text": "query Media_Query_By_Query(\n  $id: ID!\n  $idType: MediaItemIdType\n) {\n  mediaItem(id: $id, idType: $idType) {\n    mediaItemUrl\n    mimeType\n    mediaDetails {\n      sizes {\n        sourceUrl\n        name\n      }\n    }\n    description\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9b1b148c1cb4e515f7114169ac6228f";

export default node;
